/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalityarchetypedescriptionaesthete3Inputs */



/**
* | output |
* | --- |
* | "You live through feelings and aesthetics. You love deep emotional connections, beautiful visuals, heartfelt conversations, and genuine attention to details." |
*
* @param {Personalityarchetypedescriptionaesthete3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalityarchetypedescriptionaesthete3 = /** @type {((inputs?: Personalityarchetypedescriptionaesthete3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalityarchetypedescriptionaesthete3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("You live through feelings and aesthetics. You love deep emotional connections, beautiful visuals, heartfelt conversations, and genuine attention to details.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vives a través de los sentimientos y la estética. Te encantan las conexiones emocionales profundas, los buenos visuales, las charlas sinceras y la atención al detalle.")
	return /** @type {LocalizedString} */ ("Ты живешь чувствами и эстетикой. Тебе нравится глубокий эмоциональный коннект с людьми, красивый визуал, душевные разговоры и искреннее внимание к деталям.")
});
export { personalityarchetypedescriptionaesthete3 as "personalityArchetypeDescriptionAesthete" }